import { Injectable } from '@angular/core';
import { AppService, BASE_URL_API } from '../../../app.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CourseQuizService extends AppService{

  constructor(http: HttpClient) {
    super(http);
  }

  GetAlltQuizTitle<T>(coquti_in_type:number):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/courses-quiz-title/${coquti_in_type}`;
    return this.get(this.endpoint);
  }
  InsertQuizTitle<T>(datos:any):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/courses-quiz-title`;
    return this.post(this.endpoint, datos);
  }
  DeleteQuizTitle<T>(coquti_bi_id:number):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/courses-quiz-title/${coquti_bi_id}`;
    return this.delete(this.endpoint);
  }

  GetAlltQuiz<T>(coquti_bi_id:number):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/courses-quiz/${coquti_bi_id}`;
    return this.get(this.endpoint);
  }

  InsertQuiz<T>(datos:any):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/courses-quiz`;
    return this.post(this.endpoint, datos);
  }
  DeleteQuiz<T>(coqu_bi_id:number):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/courses-quiz/${coqu_bi_id}`;
    return this.delete(this.endpoint);
  }

  InsertQuizBody<T>(datos:any):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/courses-quiz-body`;
    return this.post(this.endpoint, datos);
  }

  DeleteQuizBody<T>(coqubo_bi_id:number):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/courses-quiz-body/${coqubo_bi_id}`;
    return this.delete(this.endpoint);
  }

  InsertQuizHeader<T>(datos:any):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/courses-quiz-header`;
    return this.post(this.endpoint, datos);
  }

  DeleteQuizHeader<T>(coquhe_bi_id:number):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/courses-quiz-header/${coquhe_bi_id}`;
    return this.delete(this.endpoint);
  }


  GetAlltQuizTitleAssign<T>(coquti_bi_id:number):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/courses-quiz-title-asign/${coquti_bi_id}`;
    return this.get(this.endpoint);
  }
  InsertQuizTitleAssign<T>(datos:any):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/courses-quiz-title-asign`;
    return this.post(this.endpoint, datos);
  }
  DeleteQuizTitleAssign<T>(coqutias_bi_id:number):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/courses-quiz-title-asign/${coqutias_bi_id}`;
    return this.delete(this.endpoint);
  }
}
